//? import statements
import styles from "./Menu.module.css";
import MenuItem from "../MenuItem/MenuItem";
const Menu = (props) => {
  const { menus, category } = props;
  const newMenu = menus.filter((menu) => {
    if (category === "all") {
      return menu;
    } else {
      return menu.category === category;
    }
  });

  return (
    <section className={styles["menu-container"]}>
      {newMenu.map((menu) => {
        return (
          <MenuItem key={menu.id} {...menu} />
        );
      })}
    </section>
  );
};

export default Menu;
